import React, { ReactNode } from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import './settings-row.scss';

type Props = {
  text: string;
  formField: ReactNode;
  icon?: ReactNode;
  hasError?: boolean;
  helperText?: string;
};

const SettingsRow = ({ text, formField, icon, hasError, helperText }: Readonly<Props>): React.JSX.Element => {
  return (
    <Grid container direction="column" className="settings-switch">
      <Grid container direction="row" justifyContent="flex-start" alignItems="center" gap={2}>
        {icon}
        <Grid size="grow">
          <Typography variant="subtitle1">{text}</Typography>
        </Grid>
        <Grid>{formField}</Grid>
      </Grid>
      {hasError && (
        <Grid>
          <Typography className="helper-text" variant="caption">
            {helperText}
          </Typography>
        </Grid>
      )}
    </Grid>
  );
};

export default SettingsRow;
